import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersEmployeeSurveySubmissionsIndexRequestType,
  ApiManagersEmployeeSurveySubmissionsIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersEmployeeSurveySubmissionsIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersEmployeeSurveySubmissionsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersEmployeeSurveySubmissionsIndexResponseType>(
      "/api/managers/employee_survey_submissions",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersEmployeeSurveySubmissionsIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersEmployeeSurveySubmissionsIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersEmployeeSurveySubmissionsIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersEmployeeSurveySubmissionsIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
